import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// --------------
// caution! do not delete this line. the project crash without this line. I dont know why!
// keep it unused but do not delete.
import { firebaseApp } from "./firebaseApp"; // do not delete!
// --------------'

/**
 * Pages
 */
import Home from "./pages/Home";
import SingleBlogPage from "./pages/BlogView";
import LoginPage from "./pages/Login";
import BlogsPage from "./pages/Blogs";
import CreateBlogPage from "./pages/CreateBlog";
import Dashboard from "./pages/Dashboard";
import ProjectsWithSlugWrapper from "./pages/Project";
import PreviewBlogPage from "./pages/PreviewBlogPage";
import NotFound from "./pages/404";
import VitalsDashboardView from "./pages/VitalsDashboardView";
import ProjectAdminView from "./pages/ProjectAdmin";
import BlogSeriesAdminPanel from "./pages/BlogSeriesAdmin";
import TimelineAdmin from "./pages/TimelineAdmin";
import AboutMe from "./pages/AboutMe";

/**
 * Components
 */
import ProjectDetailsMobileWrapper from "./component/project/mobile/ProjectDetailsMobileWrapper";
import ProtectedRoute from "./component/ProtectedRoute";
import ResponsiveNavbar from "./component/navigation/Navigation";
import SEO from "./utils/SEO";

/**
 * Others
 */
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowSize: window.innerWidth,
      currentUser: null, // Store authenticated user info
      loading: true, // Loading state while checking authentication
    };
  }

  updateWindowSize = () => {
    this.setState({
      windowSize: window.innerWidth,
    });
  };

  componentDidMount() {
    // Firebase is already initialized here, but you can perform operations if needed
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.setState({ currentUser: user, loading: false });
      } else {
        this.setState({ currentUser: null, loading: false });
      }
    });
    this.updateWindowSize(); // initial set
    window.addEventListener("resize", this.updateWindowSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  render() {
    const { currentUser, loading } = this.state;

    if (loading) {
      return <div></div>; // Show loading indicator while checking auth status
    }
    return (
      <Router>
        {/* Global default SEO tags */}
        <SEO />

        <div className="d-flex flex-column min-vh-100">
          <ResponsiveNavbar />

          <div className="flex-grow-1">
            <Routes>
              {/* public routes */}
              {/* Route for homepage */}
              <Route path="/" element={<Home />} />
              {/* About Me */}
              <Route path="/origin" element={<AboutMe />} />
              {/* Routes for Project - Spearate Project Page for all projects */}
              <Route path="/projects" element={<ProjectsWithSlugWrapper />} />
              {/* Route for login page */}
              <Route path="/login" element={<LoginPage />} />
              {/* Route for all blogs */}
              <Route path="/blogs" element={<BlogsPage />} />
              {/* Dynamic route for a single blog by blog ID */}
              <Route path="/blogs/:slug" element={<SingleBlogPage />} />

              {/* ✅ Mobile-only route */}
              {this.state.windowSize <= 768 ? (
                <Route
                  path="/projects/:slug"
                  element={<ProjectDetailsMobileWrapper />}
                />
              ) : (
                <Route
                  path="/projects/:slug"
                  element={<ProjectsWithSlugWrapper />} // ✅ scrolls to specific project
                />
              )}

              {/* protected routes */}
              {/* Route for dashboard page */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute user={currentUser}>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/* Web Vitals Route - Protected */}

              <Route
                path="/dashboard/vitals"
                element={
                  <ProtectedRoute user={currentUser}>
                    <VitalsDashboardView />
                  </ProtectedRoute>
                }
              />

              {/* Route for creating a new blog */}
              <Route
                path="/dashboard/create-new"
                element={
                  <ProtectedRoute user={currentUser}>
                    <CreateBlogPage />
                  </ProtectedRoute>
                }
              />

              {/* Route to Preview Blog */}
              <Route
                path="/dashboard/preview"
                element={
                  <ProtectedRoute user={currentUser}>
                    <PreviewBlogPage />
                  </ProtectedRoute>
                }
              />

              {/* Project Admin View */}
              <Route
                path="/dashboard/projects"
                element={
                  <ProtectedRoute user={currentUser}>
                    <ProjectAdminView />
                  </ProtectedRoute>
                }
              />

              {/* Blog Series Admin View */}
              <Route
                path="/dashboard/series"
                element={
                  <ProtectedRoute user={currentUser}>
                    <BlogSeriesAdminPanel />
                  </ProtectedRoute>
                }
              />

              {/* Timeline Admin */}
              <Route
                path="/dashboard/timeline"
                element={
                  <ProtectedRoute user={currentUser}>
                    <TimelineAdmin />
                  </ProtectedRoute>
                }
              />

              {/* 404 Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
